<template>
  <div></div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    stream: {
      type: OT.Stream,
      required: true
    },
    session: {
      type: OT.Session,
      required: true
    },
    options: {
      type: Object,
      required: true,
      default: {}
    }
  }
})
export default class Subscriber extends Vue {
  mounted () {
    this.subscribeStream()
  }

  handlerError (error) {
    if (error) {
      this.$emit('error', error)
    }
  }

  subscribeStream () {
    try {
      this.session.subscribe(this.stream, this.$el, this.options, this.handlerError)
    } catch (error) {
      console.log('subscribeStream ERROR:', error)
    }
  }
}
</script>
